export default{
  profiles:[
    {
      id: 0,
      cols: {
        xl: '2',
        lg: '4',
        md: '3',
        sm: '6'
      },
      title: '',
      text: 'Ryszard Andrys-Jankowski „Orlik”, „Jankowski”',
      img: '/srodowiska/okreg_wilenski/ryszard_andrys_jankowski.jpg'
    },
    {
      id: 1,
      cols: {
        xl: '2',
        lg: '4',
        md: '3',
        sm: '6'
      },
      title: '',
      text: 'Lech Iwanowski „Lancet”',
      img: '/srodowiska/okreg_wilenski/lech_iwanowski.jpg'
    },
    {
      id: 2,
      cols: {
        xl: '2',
        lg: '4',
        md: '3',
        sm: '6'
      },
      title: '',
      text: 'Ludwik Świda „Błysk”',
      img: '/srodowiska/okreg_wilenski/ludwik_swida.jpg'
    },
    {
      id: 3,
      cols: {
        xl: '2',
        lg: '4',
        md: '3',
        sm: '6'
      },
      title: '',
      text: 'Henryk Szostakowski „Czekan”',
      img: '/srodowiska/okreg_wilenski/henryk_szostakowski.jpg'
    },
    {
      id: 4,
      cols: {
        xl: '2',
        lg: '4',
        md: '3',
        sm: '6'
      },
      title: '',
      text: 'Janusz Bohdanowicz „Czortek”',
      img: '/srodowiska/okreg_wilenski/janusz_bohdanowicz.jpg'
    }
  ],
  videos:[
    {
      id: 0,
      text: 'Mauzoleum Marszałka i Cmentarz Żołnierski na Rossie Uroczyste poświęcenie dnia 13.07.1993r. (fragment)',
      url: "https://www.youtube.com/embed/RfWuflhQTis"
    },
    {
      id: 1,
      text: 'Uroczystości poświęcenia cmentarzy żołnierzy AK nad Naroczą i w Worzianach (fragment)',
      url: "https://www.youtube.com/embed/xAYhDe7v_BE"
    },
    {
      id: 2,
      text: 'Relacje żołnierzy podkomendnych płk "Kotwicza" Cmentarz w Surkontach Ostatnia walka oddziałów AK z NKWD',
      url: "https://www.youtube.com/embed/hvdAHRVztQQ"
    },
    {
      id: 3,
      text: 'Poświęcenie odbudowanego cmentarza żołnierzy Armii Krajowej w kolonii Wileńskiej 10.07.1993r. (fragment)',
      url: "https://www.youtube.com/embed/8NW6oPl3Egw"
    },
    {
      id: 4,
      text: 'Wyświęcenie odbudowanego cmentarza kwatery żołnierzy 7 brygady AK "Wilhelma" (fragment) Skorbuciany Litwa 14 lipca 1991r.',
      url: "https://www.youtube.com/embed/hyIEmZjyQX0"
    },
    {
      id: 5,
      text: 'Uroczystości poświęcenia cmentarza 6-tej brygady "Konara" w Koleśnikach dnia 9 lipca 1993r. rejon Soleczniki Litwa (fragment)',
      url: "https://www.youtube.com/embed/VqcXFE0QjPA"
    },
    {
      id: 6,
      text: 'Glinciszki koło Podbrzezia - cmentarz 38 mieszkańców Glińczyszek zamordowanych przez policję Litewską z posterunku w Podbrzeziu w dniu 30 czerwca 1944r.',
      url: "https://www.youtube.com/embed/60fmp4MPXeA"
    }
  ],
  carousel:[
    {
      id: 0,
      title: '',
      text: 'Mauzoleum Marszałka i Cmentarz Żołnierski na Rossie Uroczyste poświęcenie dnia 13.07.1993r. (fragment)',
      img: "/srodowiska/okreg_wilenski/pamiatkowy_ryngraf.jpg"
    },
    {
      id: 1,
      title: '',
      text: 'Mauzoleum Marszałka i Cmentarz Żołnierski na Rossie Uroczyste poświęcenie dnia 13.07.1993r. (fragment)',
      img: "/srodowiska/okreg_wilenski/ryngraf_3brygada.jpg"
    },
    {
      id: 2,
      title: '',
      text: 'Mauzoleum Marszałka i Cmentarz Żołnierski na Rossie Uroczyste poświęcenie dnia 13.07.1993r. (fragment)',
      img: "/srodowiska/okreg_wilenski/ryngraf_6brygada.jpg"
    },
    {
      id: 3,
      title: '',
      text: 'Mauzoleum Marszałka i Cmentarz Żołnierski na Rossie Uroczyste poświęcenie dnia 13.07.1993r. (fragment)',
      img: "/srodowiska/okreg_wilenski/ryngraf_7brygada.jpg"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/srodowiska/okreg_wilenski.js